<template>
  <div id="app">
    <!-- <router-view></router-view> -->
    <transition>
      <router-view v-if="isRouterAlive" />
    </transition>
  </div>
</template>

<script>
import router from "./router";

export default {
  name: 'app',
  data(){
    return{
      isRouterAlive: true
    }
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  methods:{
    back(){//返回上一页
      this.$router.back();
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  },
  created() {
    this.$Loading.config({
      color: '#5cb85c',
      failedColor: '#f0ad4e',
      height: 8
    });
  },
  mounted() {
    // window.addEventListener('load', () => { // 滚动事件变为 scroll
    //   if (this.$route.path !== '/index/index') { // /print 表示首页
    //     this.$router.replace('/index/index') // 切换到首页
    //   }
    // })
  }
}
</script>

<style>
@import "app.css";
</style>